import * as React from 'react';

import Bug16 from './Bug16';

export const bug16 = () => <Bug16 />;

export default {
    title: 'Icon/Line/Bug16',
    component: Bug16,
    parameters: {
        notes: "`import Bug16 from 'box-ui-elements/es/icon/line/Bug16';`",
    },
};
